import { render } from "./tw-fullcalendar.vue?vue&type=template&id=43055059"
import script from "./tw-fullcalendar.vue?vue&type=script&lang=js"
export * from "./tw-fullcalendar.vue?vue&type=script&lang=js"
script.render = render

export default script